import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import Grain from "@/components/site/Grain";
import ScrollProgress from "@/components/site/ScrollProgress";
import Home from "@/pages/Home";
import Book from "@/pages/Book";
import Schedule from "@/pages/Schedule";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useLenis();
  return (
    <div className="App grain">
      <Grain />
      <ScrollProgress />
      <Toaster position="top-center" theme="dark" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Book />} />
          <Route path="/schedule" element={<Schedule />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
